module.exports = __webpack_public_path__ + "img/Number=83.2e2a4841.png";